import { Link } from "react-router-dom";
import { resolveAssetUrl, isLikelyImageSource } from "../../config";

export function SectionPoster({
  image,
  imageUrl,
  link,
  alt = "Promotional banner",
  compact = false,
  promo = false,
}) {
  const uploaded = resolveAssetUrl(image);
  const externalRaw = imageUrl?.trim();
  const external = externalRaw && isLikelyImageSource(externalRaw)
    ? resolveAssetUrl(externalRaw)
    : "";
  const src = uploaded || external;
  if (!src) return null;

  const imgEl = (
    <img
      src={src}
      alt={alt}
      className={`w-full h-auto object-cover rounded-xl theme-banner-media transition-opacity hover:opacity-95 ${
        promo
          ? "max-h-[280px] sm:max-h-[320px] lg:max-h-[360px]"
          : compact
            ? "max-h-[220px] sm:max-h-[260px]"
            : "max-h-[400px]"
      }`}
      loading="lazy"
    />
  );

  if (!link) {
    return <div className={compact ? "mb-4" : "mb-6"}>{imgEl}</div>;
  }

  const isExternal = link.startsWith("http");
  if (isExternal) {
    return (
      <div className={compact ? "mb-4" : "mb-6"}>
        <a href={link} target="_blank" rel="noopener noreferrer">
          {imgEl}
        </a>
      </div>
    );
  }

  return (
    <div className={compact ? "mb-4" : "mb-6"}>
      <Link to={link}>{imgEl}</Link>
    </div>
  );
}
